module.exports = __webpack_public_path__ + "img/copyright.c4d971dc.png";